import * as React from "react";
import {MobXProviderContext} from 'mobx-react';
import AccessControlService from "../services/accessControl.service";

export function useAccessControl() {
  const {acl} = React.useContext<{acl: AccessControlService}>(MobXProviderContext);


  return acl;
}